import { render, staticRenderFns } from "./LazyImage.vue?vue&type=template&id=5314992e&scoped=true"
import script from "./LazyImage.vue?vue&type=script&lang=js"
export * from "./LazyImage.vue?vue&type=script&lang=js"
import style0 from "./LazyImage.vue?vue&type=style&index=0&id=5314992e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5314992e",
  null
  
)

export default component.exports